import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import * as model from '../../../models';
import { Store } from "@ngrx/store";
import { Observable } from 'rxjs/Rx';

import { AppState } from "../../../reducers";

@Component({
	selector: 'online-sale',
	template: `
			<online-sale-presentation
				[saleUrl]="saleUrl$ | async"
				[errorText]="errorText">
			</online-sale-presentation>`,
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class OnlineSaleComponent {
	private event$: Observable<model.Event>;
	private merchant$: Observable<model.Merchant>;
	private saleUrl$: Observable<String>;
	private errorText: string;

	constructor(
		private store: Store<AppState>,
	) { }

	ngOnInit() {
		this.event$ = this.store.select("eventServerState", "event", "currentEvent")
		this.merchant$ = this.store.select("merchantState", "merchant")

		this.saleUrl$ = Observable.combineLatest(this.event$, this.merchant$,
			(event, merchant) => {
				this.errorText = this.checkForError(event, merchant);
				if (!this.errorText) {
					return (merchant.merchantConfiguration.pcuiBaseUrl + '/' + event.uuid);
				}
				return null;
			}
		);
	}

	private checkForError(event, merchant): string {
		let errorMsg;
		if (!event) {errorMsg = 'Das Event konnte nicht geladen werden.'} else
		if (!merchant) {errorMsg = 'Der Merchant konnte nicht geladen werden.'} else
		if (!merchant.merchantConfiguration.pcuiBaseUrl) {errorMsg = 'Es wurde kein Link zum Online-Verkauf konfiguriert.'}
		return errorMsg;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/online-sale/online-sale.component.ts